
    <template>
      <section class="content element-doc">
        <h2>Form 表单</h2>
<p>二次封装el-form，通过json配置，数据驱动视图</p>
<h3>基础用法</h3>
<p>apex-form的基础用法</p>
<demo-block>
        <div><p>设置<code>field-list</code>属性来定义字段，设置<code>data</code>属性来配置初始化数据，<code>slot</code>属性为自定义插槽。可设置<code>showBtn</code>为<code>false</code>不显示底部按钮，默认为<code>true</code>显示。可传入<code>label-width</code>属性设置label宽度，不传默认是<code>120px</code></p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-form
  :data=&quot;formInfo.data&quot;
  :field-list=&quot;formInfo.fieldList&quot;
  :list-type-info=&quot;listTypeInfo&quot;
  :showBtn=&quot;false&quot;
  :label-width=&quot;formInfo.labelWidth&quot;
&gt;
  &lt;template slot=&quot;form-link&quot;&gt;
    &lt;apex-link to=&quot;/&quot;&gt;测试下apex-link组件 通过slot方式&lt;/apex-link&gt;
  &lt;/template&gt;
&lt;/apex-form&gt;

&lt;script&gt;
export default {
  data() {
    return {
      formInfo: {
        ref: null,
        data: {
          id: '', // *唯一ID
          account: '', // *用户账号
          password: '', // *用户密码
          name: '', // *用户昵称
          type: 2, // *用户类型: 0: 手机注册 1: 论坛注册 2: 管理平台添加
          sex: 0, // *性别: 0:男 1:女
          avatar: '', // 头像
          phone: '', // 手机号码
          wechat: '', // 微信
          qq: '', // qq
          email: '', // 邮箱
          desc: '', // 描述
          status: 1 // *状态: 0：停用，1：启用(默认为1)',
        },
        fieldList: [
          { label: '账号', value: 'account', type: 'input' },
          { label: '密码', value: 'password', type: 'password' },
          { label: '昵称', value: 'name', type: 'input' },
          { label: '性别', value: 'sex', type: 'select', list: 'sexList' },
          { label: '链接', value: 'link', type: 'slot', className: 'el-form-block' },
          { label: '手机号码', value: 'phone', type: 'input' },
          { label: '微信', value: 'wechat', type: 'input' },
          { label: 'QQ', value: 'qq', type: 'input' },
          { label: '邮箱', value: 'email', type: 'input' },
          { label: '描述', value: 'desc', type: 'textarea', className: 'el-form-block' },
          { label: '状态', value: 'status', type: 'select', list: 'statusList' }
        ],
        labelWidth: '100px'
      },
      listTypeInfo: {
        sexList: [
          { key: '男', value: 0 },
          { key: '女', value: 1 }
        ],
        statusList: [
          { key: '停用', value: 0 },
          { key: '启用', value: 1 }
        ]
      }
    }
  }
};
&lt;/script&gt;
</code></pre></template></demo-block><h3>带分割线标题的</h3>
<p>带分割线标题的用法</p>
<demo-block>
        <div><p>在<code>field-list</code>里设置某一项的<code>type</code>为<code>title</code>即可，示例如下：</p>
</div>
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-form
  :data=&quot;formInfo.data&quot;
  :field-list=&quot;formInfo.fieldList&quot;
  :list-type-info=&quot;listTypeInfo&quot;
  :showBtn=&quot;false&quot;
  :label-width=&quot;formInfo.labelWidth&quot;
&gt;
  &lt;template slot=&quot;form-link&quot;&gt;
    &lt;apex-link to=&quot;/&quot;&gt;测试下apex-link组件 通过slot方式&lt;/apex-link&gt;
  &lt;/template&gt;
&lt;/apex-form&gt;

&lt;script&gt;
export default {
  data() {
    return {
      formInfo: {
        ref: null,
        data: {
          id: '', // *唯一ID
          account: '', // *用户账号
          password: '', // *用户密码
          name: '', // *用户昵称
          type: 2, // *用户类型: 0: 手机注册 1: 论坛注册 2: 管理平台添加
          sex: 0, // *性别: 0:男 1:女
          avatar: '', // 头像
          phone: '', // 手机号码
          wechat: '', // 微信
          qq: '', // qq
          email: '', // 邮箱
          desc: '', // 描述
          status: 1 // *状态: 0：停用，1：启用(默认为1)',
        },
        fieldList: [
          { type: 'title', title: '标题1' },
          { label: '账号', value: 'account', type: 'input' },
          { label: '密码', value: 'password', type: 'password' },
          { label: '昵称', value: 'name', type: 'input' },
          { label: '性别', value: 'sex', type: 'select', list: 'sexList' },
          { type: 'title', title: '标题2' },
          { label: '链接', value: 'link', type: 'slot', className: 'el-form-block' },
          { type: 'title', title: '标题3' },
          { label: '手机号码', value: 'phone', type: 'input' },
          { label: '微信', value: 'wechat', type: 'input' },
          { label: 'QQ', value: 'qq', type: 'input' },
          { label: '邮箱', value: 'email', type: 'input' },
          { label: '描述', value: 'desc', type: 'textarea', className: 'el-form-block' },
          { label: '状态', value: 'status', type: 'select', list: 'statusList' }
        ],
        labelWidth: '100px'
      },
      listTypeInfo: {
        sexList: [
          { key: '男', value: 0 },
          { key: '女', value: 1 }
        ],
        statusList: [
          { key: '停用', value: 0 },
          { key: '启用', value: 1 }
        ]
      }
    }
  }
};
&lt;/script&gt;
</code></pre></template></demo-block><h3>表单校验</h3>
<p>表单校验使用</p>
<demo-block>
        <div><p>可通过在 apex-form 传<code>rules</code>参数（详细配置参考 <a href="https://element.eleme.cn/#/zh-CN/component/form#biao-dan-yan-zheng" target="_blank">element-ui 官网</a> 文档）或者在<code>field-list</code>配置<code>validator</code>来自定义制定校验规则，可以添加<code>required: true</code>直接设置必填项。</p>
</div>
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-form
  ref=&quot;apexForm&quot;
  :data=&quot;formInfo.data&quot;
  :field-list=&quot;formInfo.fieldList&quot;
  :list-type-info=&quot;listTypeInfo&quot;
  :rules=&quot;formInfo.rules&quot;
&gt;&lt;/apex-form&gt;
&lt;el-button @click=&quot;customSubmit&quot;&gt;自定义提交按钮&lt;/el-button&gt;

&lt;script&gt;
export default {
  data() {
    let checkPhone = (rule, value, callback) =&gt; {
      const reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
      if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('手机号格式错误'))
      }
    }
    return {
      formInfo: {
        ref: null,
        data: {
          id: '', // *唯一ID
          account: '', // *用户账号
          password: '', // *用户密码
          name: '', // *用户昵称
          type: 2, // *用户类型: 0: 手机注册 1: 论坛注册 2: 管理平台添加
          sex: 0, // *性别: 0:男 1:女
          avatar: '', // 头像
          phone: '', // 手机号码
          wechat: '', // 微信
          qq: '', // qq
          email: '', // 邮箱
          desc: '', // 描述
          status: null, // *状态: 0：停用，1：启用(默认为1)',
          date: ''
        },
        fieldList: [
          { label: '账号', value: 'account', type: 'input', required: true },
          { label: '密码', value: 'password', type: 'password', required: true },
          { label: '昵称', value: 'name', type: 'input', required: true },
          { label: '性别', value: 'sex', type: 'select', list: 'sexList', required: true },
          { label: '手机号码', value: 'phone', type: 'input', validator: checkPhone, trigger: 'change' },
          { label: '微信', value: 'wechat', type: 'input' },
          { label: 'QQ', value: 'qq', type: 'input' },
          { label: '邮箱', value: 'email', type: 'input' },
          { label: '描述', value: 'desc', type: 'textarea', className: 'el-form-block' },
          { label: '状态', value: 'status', type: 'select', list: 'statusList', required: true },
          { label: '日期', value: 'date', type: 'date', required: true }
        ],
        rules: {
          account: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'change' }
          ]
        }
      },
      listTypeInfo: {
        sexList: [
          { key: '男', value: 0 },
          { key: '女', value: 1 }
        ],
        statusList: [
          { key: '停用', value: 0 },
          { key: '启用', value: 1 }
        ]
      }
    }
  },
  methods: {
    customSubmit() {
      this.$refs.apexForm.submitForm().then(res =&gt; {
        console.log(res)
      })
    }
  }
};
&lt;/script&gt;
</code></pre></template></demo-block><h3>提交表单</h3>
<p>提交表单相关配置使用</p>
<demo-block>
        <div><p>点击提交按钮，当校验规则不满足时会触发校验不通过状态，页面会自动滚动到第一个校验未通过的地方。当所有校验通过时，会触发<code>@submit</code>回调函数，当点击重置时会重置表单数据到初始值和清除校验状态，并触发<code>@cancle</code>回调函数。可通过设置<code>submitBtnText</code>属性来自定义提交按钮文字，设置<code>cancleBtnText</code>属性来自定义重置按钮文字。</p>
</div>
        <template slot="source"><element-demo3 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-form
  :data=&quot;formInfo.data&quot;
  :field-list=&quot;formInfo.fieldList&quot;
  :list-type-info=&quot;listTypeInfo&quot;
  submitBtnText=&quot;立即创建&quot;
  cancleBtnText=&quot;取消&quot;
  @submit=&quot;submit&quot;
  @cancle=&quot;cancle&quot;
&gt;&lt;/apex-form&gt;

&lt;script&gt;
export default {
  data() {
    return {
      formInfo: {
        ref: null,
        data: {
          id: '', // *唯一ID
          account: '', // *用户账号
          password: '', // *用户密码
          name: '', // *用户昵称
          type: 2, // *用户类型: 0: 手机注册 1: 论坛注册 2: 管理平台添加
          sex: 0, // *性别: 0:男 1:女
          avatar: '', // 头像
          phone: '', // 手机号码
          wechat: '', // 微信
          qq: '', // qq
          email: '', // 邮箱
          desc: '', // 描述
          status: null // *状态: 0：停用，1：启用(默认为1)',
        },
        fieldList: [
          { label: '账号', value: 'account', type: 'input', required: true },
          { label: '密码', value: 'password', type: 'password', required: true },
          { label: '昵称', value: 'name', type: 'input', required: true },
          { label: '性别', value: 'sex', type: 'select', list: 'sexList', required: true },
          { label: '手机号码', value: 'phone', type: 'input', required: true },
          { label: '微信', value: 'wechat', type: 'input' },
          { label: 'QQ', value: 'qq', type: 'input' },
          { label: '邮箱', value: 'email', type: 'input' },
          { label: '描述', value: 'desc', type: 'textarea', className: 'el-form-block' },
          { label: '状态', value: 'status', type: 'select', list: 'statusList', required: true, trigger: 'change' }
        ]
      },
      listTypeInfo: {
        sexList: [
          { key: '男', value: 0 },
          { key: '女', value: 1 }
        ],
        statusList: [
          { key: '停用', value: 0 },
          { key: '启用', value: 1 }
        ]
      }
    }
  },
  methods: {
    submit() {
      this.$message.success('校验通过')
    },
    cancle() {
      this.$message('点击了取消按钮')
    }
  }
};
&lt;/script&gt;
</code></pre></template></demo-block><h3>apex-form Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>data</td>
<td>表单数据</td>
<td>object</td>
<td>—</td>
<td>{}</td>
</tr>
<tr>
<td>field-list</td>
<td>表单配置项</td>
<td>array</td>
<td>—</td>
<td>[]</td>
</tr>
<tr>
<td>list-type-info</td>
<td>相关列表</td>
<td>object</td>
<td>—</td>
<td>{}</td>
</tr>
<tr>
<td>rules</td>
<td>验证规则</td>
<td>object</td>
<td>—</td>
<td>{}</td>
</tr>
<tr>
<td>label-width</td>
<td>label宽度</td>
<td>string</td>
<td>—</td>
<td>120px</td>
</tr>
<tr>
<td>refObj</td>
<td>ref相关</td>
<td>object</td>
<td>—</td>
<td>{}</td>
</tr>
<tr>
<td>showBtn</td>
<td>是否显示底部操作按钮</td>
<td>Boolean</td>
<td>true/false</td>
<td>true</td>
</tr>
<tr>
<td>className</td>
<td>自定义类名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>size</td>
<td>表单大小</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>submitBtnText</td>
<td>提交按钮文字</td>
<td>string</td>
<td>—</td>
<td>提交</td>
</tr>
<tr>
<td>cancleBtnText</td>
<td>重置按钮文字</td>
<td>string</td>
<td>—</td>
<td>重置</td>
</tr>
</tbody>
</table>
<h3>field-list Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>label</td>
<td>label文字</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>value</td>
<td>data对应的字段名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>type</td>
<td>类型</td>
<td>string</td>
<td>input / password / textarea / inputNumber / select / date / tag / slot</td>
<td>—</td>
</tr>
<tr>
<td>list</td>
<td>type为 select 时下拉框options对应的数组名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>emit</td>
<td>emit事件名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>show</td>
<td>是否显示</td>
<td>boolean</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>className</td>
<td>自定义类名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>required</td>
<td>是否必填</td>
<td>boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
<tr>
<td>validator</td>
<td>自定义校验规则</td>
<td>function</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>trigger</td>
<td>触发方式</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>list-type-info Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>key</td>
<td>下拉框显示文字</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>value</td>
<td>下拉框文字对应的值</td>
<td>any</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>apex-form Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>submit</td>
<td>提交按钮校验通过后的回调</td>
<td>—</td>
</tr>
<tr>
<td>cancle</td>
<td>重置按钮的回调</td>
<td>—</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-form',{attrs:{"data":_vm.formInfo.data,"field-list":_vm.formInfo.fieldList,"list-type-info":_vm.listTypeInfo,"showBtn":false,"label-width":_vm.formInfo.labelWidth}},[_c('template',{slot:"form-link"},[_c('apex-link',{attrs:{"to":"/"}},[_vm._v("测试下apex-link组件 通过slot方式")])],1)],2)],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      formInfo: {
        ref: null,
        data: {
          id: '', // *唯一ID
          account: '', // *用户账号
          password: '', // *用户密码
          name: '', // *用户昵称
          type: 2, // *用户类型: 0: 手机注册 1: 论坛注册 2: 管理平台添加
          sex: 0, // *性别: 0:男 1:女
          avatar: '', // 头像
          phone: '', // 手机号码
          wechat: '', // 微信
          qq: '', // qq
          email: '', // 邮箱
          desc: '', // 描述
          status: 1 // *状态: 0：停用，1：启用(默认为1)',
        },
        fieldList: [
          { label: '账号', value: 'account', type: 'input' },
          { label: '密码', value: 'password', type: 'password' },
          { label: '昵称', value: 'name', type: 'input' },
          { label: '性别', value: 'sex', type: 'select', list: 'sexList' },
          { label: '链接', value: 'link', type: 'slot', className: 'el-form-block' },
          { label: '手机号码', value: 'phone', type: 'input' },
          { label: '微信', value: 'wechat', type: 'input' },
          { label: 'QQ', value: 'qq', type: 'input' },
          { label: '邮箱', value: 'email', type: 'input' },
          { label: '描述', value: 'desc', type: 'textarea', className: 'el-form-block' },
          { label: '状态', value: 'status', type: 'select', list: 'statusList' }
        ],
        labelWidth: '100px'
      },
      listTypeInfo: {
        sexList: [
          { key: '男', value: 0 },
          { key: '女', value: 1 }
        ],
        statusList: [
          { key: '停用', value: 0 },
          { key: '启用', value: 1 }
        ]
      }
    }
  }
};
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-form',{attrs:{"data":_vm.formInfo.data,"field-list":_vm.formInfo.fieldList,"list-type-info":_vm.listTypeInfo,"showBtn":false,"label-width":_vm.formInfo.labelWidth}},[_c('template',{slot:"form-link"},[_c('apex-link',{attrs:{"to":"/"}},[_vm._v("测试下apex-link组件 通过slot方式")])],1)],2)],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      formInfo: {
        ref: null,
        data: {
          id: '', // *唯一ID
          account: '', // *用户账号
          password: '', // *用户密码
          name: '', // *用户昵称
          type: 2, // *用户类型: 0: 手机注册 1: 论坛注册 2: 管理平台添加
          sex: 0, // *性别: 0:男 1:女
          avatar: '', // 头像
          phone: '', // 手机号码
          wechat: '', // 微信
          qq: '', // qq
          email: '', // 邮箱
          desc: '', // 描述
          status: 1 // *状态: 0：停用，1：启用(默认为1)',
        },
        fieldList: [
          { type: 'title', title: '标题1' },
          { label: '账号', value: 'account', type: 'input' },
          { label: '密码', value: 'password', type: 'password' },
          { label: '昵称', value: 'name', type: 'input' },
          { label: '性别', value: 'sex', type: 'select', list: 'sexList' },
          { type: 'title', title: '标题2' },
          { label: '链接', value: 'link', type: 'slot', className: 'el-form-block' },
          { type: 'title', title: '标题3' },
          { label: '手机号码', value: 'phone', type: 'input' },
          { label: '微信', value: 'wechat', type: 'input' },
          { label: 'QQ', value: 'qq', type: 'input' },
          { label: '邮箱', value: 'email', type: 'input' },
          { label: '描述', value: 'desc', type: 'textarea', className: 'el-form-block' },
          { label: '状态', value: 'status', type: 'select', list: 'statusList' }
        ],
        labelWidth: '100px'
      },
      listTypeInfo: {
        sexList: [
          { key: '男', value: 0 },
          { key: '女', value: 1 }
        ],
        statusList: [
          { key: '停用', value: 0 },
          { key: '启用', value: 1 }
        ]
      }
    }
  }
};
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-form',{ref:"apexForm",attrs:{"data":_vm.formInfo.data,"field-list":_vm.formInfo.fieldList,"list-type-info":_vm.listTypeInfo,"rules":_vm.formInfo.rules}}),_vm._v(" "),_c('el-button',{on:{"click":_vm.customSubmit}},[_vm._v("自定义提交按钮")])],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    let checkPhone = (rule, value, callback) => {
      const reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
      if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('手机号格式错误'))
      }
    }
    return {
      formInfo: {
        ref: null,
        data: {
          id: '', // *唯一ID
          account: '', // *用户账号
          password: '', // *用户密码
          name: '', // *用户昵称
          type: 2, // *用户类型: 0: 手机注册 1: 论坛注册 2: 管理平台添加
          sex: 0, // *性别: 0:男 1:女
          avatar: '', // 头像
          phone: '', // 手机号码
          wechat: '', // 微信
          qq: '', // qq
          email: '', // 邮箱
          desc: '', // 描述
          status: null, // *状态: 0：停用，1：启用(默认为1)',
          date: ''
        },
        fieldList: [
          { label: '账号', value: 'account', type: 'input', required: true },
          { label: '密码', value: 'password', type: 'password', required: true },
          { label: '昵称', value: 'name', type: 'input', required: true },
          { label: '性别', value: 'sex', type: 'select', list: 'sexList', required: true },
          { label: '手机号码', value: 'phone', type: 'input', validator: checkPhone, trigger: 'change' },
          { label: '微信', value: 'wechat', type: 'input' },
          { label: 'QQ', value: 'qq', type: 'input' },
          { label: '邮箱', value: 'email', type: 'input' },
          { label: '描述', value: 'desc', type: 'textarea', className: 'el-form-block' },
          { label: '状态', value: 'status', type: 'select', list: 'statusList', required: true },
          { label: '日期', value: 'date', type: 'date', required: true }
        ],
        rules: {
          account: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'change' }
          ]
        }
      },
      listTypeInfo: {
        sexList: [
          { key: '男', value: 0 },
          { key: '女', value: 1 }
        ],
        statusList: [
          { key: '停用', value: 0 },
          { key: '启用', value: 1 }
        ]
      }
    }
  },
  methods: {
    customSubmit() {
      this.$refs.apexForm.submitForm().then(res => {
        console.log(res)
      })
    }
  }
};
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-form',{attrs:{"data":_vm.formInfo.data,"field-list":_vm.formInfo.fieldList,"list-type-info":_vm.listTypeInfo,"submitBtnText":"立即创建","cancleBtnText":"取消"},on:{"submit":_vm.submit,"cancle":_vm.cancle}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      formInfo: {
        ref: null,
        data: {
          id: '', // *唯一ID
          account: '', // *用户账号
          password: '', // *用户密码
          name: '', // *用户昵称
          type: 2, // *用户类型: 0: 手机注册 1: 论坛注册 2: 管理平台添加
          sex: 0, // *性别: 0:男 1:女
          avatar: '', // 头像
          phone: '', // 手机号码
          wechat: '', // 微信
          qq: '', // qq
          email: '', // 邮箱
          desc: '', // 描述
          status: null // *状态: 0：停用，1：启用(默认为1)',
        },
        fieldList: [
          { label: '账号', value: 'account', type: 'input', required: true },
          { label: '密码', value: 'password', type: 'password', required: true },
          { label: '昵称', value: 'name', type: 'input', required: true },
          { label: '性别', value: 'sex', type: 'select', list: 'sexList', required: true },
          { label: '手机号码', value: 'phone', type: 'input', required: true },
          { label: '微信', value: 'wechat', type: 'input' },
          { label: 'QQ', value: 'qq', type: 'input' },
          { label: '邮箱', value: 'email', type: 'input' },
          { label: '描述', value: 'desc', type: 'textarea', className: 'el-form-block' },
          { label: '状态', value: 'status', type: 'select', list: 'statusList', required: true, trigger: 'change' }
        ]
      },
      listTypeInfo: {
        sexList: [
          { key: '男', value: 0 },
          { key: '女', value: 1 }
        ],
        statusList: [
          { key: '停用', value: 0 },
          { key: '启用', value: 1 }
        ]
      }
    }
  },
  methods: {
    submit() {
      this.$message.success('校验通过')
    },
    cancle() {
      this.$message('点击了取消按钮')
    }
  }
};
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  